import { withRouter } from 'react-router';
import { Switch, Route } from 'react-router-dom';
import ROPatientDiagnosisPage from './DiagnosisPages/DiagnosisPage';
import ROPatientTreatmentInfoPage from './TreatmentInfoPage/TreatmentInfoPage';
import ROPatientCarePathTemplatePage from './TemplatePage/TemplatePage';
import ROPatientVolumingPage from './VolumingPage/VolumingPage';
import ROPatientTreatmentSimulationPage from './SimulationPage/SimulationPage';
import ROPatientPrescriptionPage from './PrescriptionPage/PrescriptionPage';
import ROPatientTreatmentSubmissionPage from './SubmissionPage/SubmissionPage';
import ROPatientCarePathSiteSetupPage from './SiteSetupPage/SiteSetupPage';
import ROPatientSpecialPhysicsConsult from './SpecialPhysicsConsultPage/SpecialPhysicsConsultPage';
import { CAREPLAN_PAGES } from './Constants';
import { PeerReviewProvider } from './PeerReviewContext';
import MRLSafetyScreeningPage from './MRLSafetyScreening/MRLSafetyScreeningPage';
import { useTenantAppConfig } from 'op-utils/useTenantAppConfig';

const ROPatientCarePlanPageRouter = () => {
  const tenantAppConfig = useTenantAppConfig();
  const showSpecialPhysicsConsultPage = tenantAppConfig.SpecialPhysicsConsultVisible;
  return (
    <PeerReviewProvider>
      <Switch>
        {showSpecialPhysicsConsultPage && (
          <Route
            path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.SPECIAL_PHYSICS_CONSULT}/:prescriptionIdx?`}
            component={ROPatientSpecialPhysicsConsult}
          />
        )}
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.VOLUMING}/:prescriptionIdx?`}
          component={ROPatientVolumingPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.SUBMISSION}`}
          component={ROPatientTreatmentSubmissionPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.PRESCRIPTION}/:siteIdx?`}
          component={ROPatientPrescriptionPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.MRL_SAFETY_SCREENING}`}
          component={MRLSafetyScreeningPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.SIMULATION}/:siteGroupIdx?`}
          component={ROPatientTreatmentSimulationPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.TEMPLATE_SELECTION}`}
          component={ROPatientCarePathTemplatePage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.TREATMENT_INFO}`}
          component={ROPatientTreatmentInfoPage}
        />
        <Route
          path={`/:oncologyType/patient/:id/careplan/:careplanId/${CAREPLAN_PAGES.SITESETUP}`}
          component={ROPatientCarePathSiteSetupPage}
        />
        <Route path="/:oncologyType/patient/:id/careplan/:careplanId/" component={ROPatientDiagnosisPage} />
      </Switch>
    </PeerReviewProvider>
  );
};

const routedComponent = withRouter(ROPatientCarePlanPageRouter);
export default routedComponent;
